var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-flex align-center"},[_c('v-icon',{attrs:{"disabled":_vm.isDashboard,"small":"","color":"techBlue"},on:{"click":_vm.onRootIconClick}},[_vm._v(" "+_vm._s(_vm.rootIcon)+" ")]),(!_vm.isDashboard)?_c('v-icon',{staticClass:"mx-1",attrs:{"color":"techBlueDark","small":""}},[_vm._v(" mdi-chevron-right ")]):_vm._e(),(!_vm.isDashboard)?_c('div',{class:[
      'text-body-2',
      'text--secondary',
      { 'truncate-text': _vm.shouldTruncate },
    ],attrs:{"title":_vm.shouldTruncate ? _vm.label : ''}},[_vm._v(" "+_vm._s(_vm.label)+" ")]):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }